import { isLabelDimension } from 'src/app/warehousing/services/label-layout';
import { Injectable } from '@angular/core';
import { ValidatorService } from 'src/app/core/validator/validator.service';
import { EnvironmentSettings } from '../models/environment-settings.model';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentValidatorService extends ValidatorService {
  isValid(data: EnvironmentSettings) {
    this.errors = [];
    

    if(!this.isSupplied(data.companyName)) {
      this.errors.push('companyName');
    }

    if(!this.isSupplied(data.comnpanyNumber)) {
      this.errors.push('comnpanyNumber');
    }

    if(!this.isSupplied(data.address1)) {
      this.errors.push('address1');
    }

    if(!this.isSupplied(data.address2)) {
      this.errors.push('address2');
    }

    if(!this.isSupplied(data.addressPostcode)) {
      this.errors.push('addressPostcode');
    }

    if(!this.isSupplied(data.addressEmail)) {
      this.errors.push('addressEmail');
    }

    if(!this.isSupplied(data.addressPhone)) {
      this.errors.push('addressPhone');
    }

    if(!isLabelDimension(Number(data.labelWidthMm))) {
      this.errors.push('labelWidthMm');
    }

    if(!isLabelDimension(Number(data.labelHeightMm))) {
      this.errors.push('labelHeightMm');
    }

    const extraDays = Number(data.storageExtraDays);
    if(!Number.isInteger(extraDays) || extraDays < 0 || extraDays > 7) {
      this.errors.push('storageExtraDays');
    }


    return this.errors.length === 0;
  }
}
